export const initialState = {
    firstFormCompleted: false,
    iiipol: '',
    intpol: '',
    questions_product: '',
    errorEncrypt: false,
    codpme: '',
    paramsMus: {},
    userContainProduct: false,
    typeBeneficiary: '',
    completedPurchase: false,
    addOtherBeneficiary: false,
    editBeneficiares: false,
    clientContainPlan: '',
    statePlanDetail: '',
    stateError: '',
    globalTab: 0,
    currentTab: 0,
    login: {},
    codpmpol: '',
    altCodpmpol: '',
    steps: [],
    loading: false,
    user: {
        login: false,
        nro: '',
        origen: '',
    },
    firstStep: {
        fecpro: '',
        plan: '',
        codpro: '',
        price: '',
        codsec: '',
        codcia: '',
    },
    titularData: {
        name: '',
        lastname: '',
        dni: '',
        email: '',
        city: '',
        province: '',
        area: '',
        phone: '',
        address: '',
        numAddress: '',
        birthday: '',
        genre: '',
        activity: 0,
        nationality: '54',
        expose: 'no',
        year: new Date().getFullYear(),
    },
    homeData: {
        address: '',
        homeType: '',
        province: '',
        // numAddress: '',
        // department: '',
        city: '',
        squareMeters: '',
        registeredAddress: '',
    },
    payMethod: {
        creditCard: '',
        cardNumber: '',
        fullName: '',
        dni: '',
        expires: '',
    },
    protectedNotebook: {
        brand: '',
        model: '',
        name: '',
        lastname: '',
        dni: '',
        birthdate: '',
    },
    protectedTecnology: {
        name: '',
        lastname: '',
        dni: '',
        birthdate: '',
    },
    beneficiaryData: [],
    additionalData: ''
};